import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from 'locales/en.json';
import translationSC from 'locales/sc.json';

const resources = {
    'en-US': {
        translation: translationEN
    },
    'zh-CN': {
        translation: translationSC
    }
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'lang'
        },
        fallbackLng: 'en-US',
        interplation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        },
        compatibilityJSON: 'v4'
    });

export default i18n;
